import { Button, Container, DialogActions, DialogContent, DialogTitle, Paper, Typography } from '@mui/material';
import React from 'react';
import { useApp } from '@app/App.hook';

export const NotRegistered = () => {
  const { logout } = useApp();

  return (
    <Container sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', height: '100vh' }}>
      <Paper sx={{ width: '100%', maxWidth: '500px' }}>
        <DialogTitle>User is not registered</DialogTitle>
        <DialogContent>
          <Typography>
            Users must be registered with We Hate Exercise to access the platform. Check back as things are always
            changing!
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant={'contained'} onClick={logout} sx={{ margin: '0 auto 25px', width: '80%' }}>
            Logout
          </Button>
        </DialogActions>
      </Paper>
    </Container>
  );
};
